import React, {useState} from 'react'
import {Button, message, Modal, Popconfirm, Select} from 'antd';
import {addNumberToTest} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {Option} from "antd/es/mentions";

function TestNumberModal(props) {
    const decodeToken = parseToken()
    const [telco, setTelco] = useState('')
    const {showModal, toggleModal, custId, listTelco, fetchListTenantNumber, selectedRowKeys, resetRowKeys} = props
    const [loading, setLoading] = useState(false)

    const handleCancel = () => {
        toggleModal()
    }

    const onChangeTelco = (value) => {
        setTelco(value)
    }

    const onIsolationNumber = async () => {
        try {
            const payload = {
                telco,
                phone: selectedRowKeys.map(item => item.phoneNumber),
                tenantId: custId
            }
            const response = await addNumberToTest(decodeToken.sub, payload)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            message.success('Test thành công!')
            toggleModal()
            resetRowKeys()
            fetchListTenantNumber()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return <Modal
        title="Test số"
        className={`ModalCustom2`}
        style={{top: 20}}
        maskClosable={false}
        open={showModal}
        footer={[
            <div className="Actions d-flex justify-content-end align-items-center">
                <Button onClick={onIsolationNumber} key="submit" type="primary" loading={loading}>
                    Test số
                </Button>
                <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                            cancelText="No">
                    <Button key="back" type="link" disable={loading}>
                        Cancel
                    </Button>
                </Popconfirm>
            </div>
        ]}
    >
        <div className="FormAddNew">
            <div className="row">
                <div className="FormField col-md-12">
                    <label className="Label">
                        Chọn hướng test
                    </label>
                    <Select onChange={onChangeTelco} placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                        {
                            listTelco.map(item => {
                                return <Option value={item.code} key={item.code}>{item.name}</Option>
                            })
                        }
                    </Select>
                </div>
            </div>
        </div>
    </Modal>
}

export default TestNumberModal
